{
  "signIn": {
    "title": "Connexion",
    "subtitle": "Bon retour. Connectez-vous pour gérer vos appareils et vos messages.",
    "email": "Adresse e-mail",
    "password": "Mot de passe",
    "forgot": "Mot de passe oublié ?",
    "submit": "Se connecter",
    "submitting": "Connexion…",
    "or": "ou",
    "noAccount": "Pas encore de compte ?",
    "register": "Créer un compte",
    "invalidCredentials": "L’e-mail ou le mot de passe est incorrect. Après cinq tentatives erronées, le compte est bloqué pendant 15 minutes.",
    "rateLimited": "Trop de tentatives. Vous pourrez réessayer dans {{time}}.",
    "rateLimitedLead": "Trop de tentatives. Vous pourrez réessayer dans",
    "rateLimitedNoTime": "Trop de tentatives. Patientez quelques minutes avant de réessayer.",
    "googleUnavailable": "La connexion Google n’a pas pu être chargée. Utilisez votre e-mail et votre mot de passe."
  },
  "notice": {
    "reused": "Cette session a été utilisée depuis un autre endroit et a été fermée. Reconnectez-vous.",
    "expired": "Votre session a pris fin. Reconnectez-vous.",
    "banned": "Ce compte est désactivé. Contactez le support si vous pensez qu’il s’agit d’une erreur.",
    "challenge": "Cette étape de vérification a expiré. Reconnectez-vous pour en obtenir une nouvelle.",
    "reset": "Votre mot de passe a été modifié et toutes les sessions ont été fermées. Connectez-vous avec le nouveau mot de passe.",
    "idle": "Vous avez été déconnecté après 30 minutes sans activité. Reconnectez-vous pour continuer."
  },
  "totp": {
    "title": "Vérification en deux étapes",
    "subtitle": "Saisissez le code à 6 chiffres de votre application d’authentification.",
    "recoverySubtitle": "Saisissez l’un des codes de récupération enregistrés lors de l’activation de la vérification en deux étapes.",
    "code": "Code de vérification",
    "recoveryCode": "Code de récupération",
    "useRecovery": "Utiliser plutôt un code de récupération",
    "useApp": "Utiliser plutôt un code de l’application",
    "submit": "Vérifier",
    "submitting": "Vérification…",
    "back": "Retour à la connexion"
  },
  "register": {
    "title": "Créer votre compte",
    "subtitle": "Envoyez des SMS depuis vos propres téléphones Android, avec un seul tableau de bord.",
    "name": "Nom complet",
    "optional": "facultatif",
    "email": "Adresse e-mail",
    "password": "Mot de passe",
    "passwordHint": "De 8 à 128 caractères.",
    "phone": "Téléphone",
    "language": "Langue de vos e-mails",
    "submit": "Créer le compte",
    "submitting": "Création…",
    "haveAccount": "Vous avez déjà un compte ?",
    "signIn": "Se connecter",
    "doneTitle": "Consultez vos e-mails",
    "doneBody": "Nous avons envoyé un lien de confirmation à {{email}}. Ouvrez-le pour confirmer votre adresse, puis connectez-vous.",
    "toSignIn": "Aller à la connexion"
  },
  "verify": {
    "title": "Confirmer votre e-mail",
    "checking": "Confirmation de votre adresse…",
    "doneTitle": "E-mail confirmé",
    "doneBody": "Merci. Votre adresse est confirmée.",
    "toDashboard": "Aller au tableau de bord",
    "toSignIn": "Aller à la connexion",
    "invalidTitle": "Ce lien ne fonctionne plus",
    "missingToken": "Ce lien est incomplet. Ouvrez de nouveau le lien de l’e-mail, sans le modifier.",
    "resend": "M’envoyer un nouveau lien",
    "resending": "Envoi…",
    "resent": "Un nouveau lien est en route. Consultez votre boîte de réception.",
    "signInToResend": "Connectez-vous pour demander un nouveau lien."
  },
  "unsubscribe": {
    "title": "Ne plus recevoir ces e-mails ?",
    "body": "Vous ne recevrez plus ce type d’e-mail facultatif. Les e-mails de sécurité, de paiement et de forfait vous parviennent toujours.",
    "confirm": "Ne plus recevoir ces e-mails",
    "confirming": "Enregistrement…",
    "doneTitle": "Désabonnement effectué",
    "done_usageAlerts": "Vous ne recevrez plus les alertes de consommation.",
    "done_creditWarnings": "Vous ne recevrez plus les alertes de crédit.",
    "manage": "Gérer mes préférences d’e-mail",
    "invalidTitle": "Ce lien ne fonctionne plus",
    "missingToken": "Ce lien est incomplet. Ouvrez-le à nouveau depuis l’e-mail, sans le modifier."
  },
  "forgot": {
    "title": "Réinitialiser le mot de passe",
    "subtitle": "Saisissez l’e-mail de votre compte. Nous vous enverrons un code à 6 chiffres.",
    "email": "Adresse e-mail",
    "submit": "Envoyer le code",
    "submitting": "Envoi…",
    "sentTitle": "Consultez vos e-mails",
    "sentBody": "Si un compte existe pour {{email}}, un code à 6 chiffres est en route. Il expire au bout de peu de temps.",
    "enterCode": "Saisir le code",
    "back": "Retour à la connexion"
  },
  "reset": {
    "title": "Choisir un nouveau mot de passe",
    "subtitle": "Saisissez le code à 6 chiffres reçu par e-mail, puis votre nouveau mot de passe.",
    "email": "Adresse e-mail",
    "otp": "Code à 6 chiffres",
    "newPassword": "Nouveau mot de passe",
    "confirm": "Confirmer le nouveau mot de passe",
    "submit": "Changer le mot de passe",
    "submitting": "Modification…",
    "requestCode": "Pas de code ? En demander un nouveau",
    "back": "Retour à la connexion"
  },
  "invite": {
    "title": "Rejoindre l’équipe",
    "subtitle": "Choisissez votre nom et votre mot de passe pour accepter l’invitation.",
    "name": "Nom complet",
    "password": "Mot de passe",
    "submit": "Accepter et se connecter",
    "submitting": "Connexion…",
    "missingToken": "Ce lien d’invitation est incomplet. Ouvrez de nouveau le lien de l’e-mail, sans le modifier.",
    "toSignIn": "Aller à la connexion"
  },
  "enrol": {
    "title": "Activer la vérification en deux étapes",
    "subtitle": "Les comptes du personnel doivent confirmer chaque connexion avec une application d’authentification. Cela prend une minute.",
    "passwordIntro": "Confirmez d’abord votre mot de passe.",
    "password": "Mot de passe",
    "continue": "Continuer",
    "checking": "Vérification…",
    "scan": "Scannez ce code QR avec votre application d’authentification, puis saisissez le code à 6 chiffres qu’elle affiche.",
    "recoveryTitle": "Enregistrez vos codes de récupération",
    "recoverySubtitle": "Chaque code vous connecte une fois si vous perdez votre téléphone.",
    "stepUpExpired": "Votre confirmation a expiré. Saisissez de nouveau votre mot de passe."
  },
  "validation": {
    "required": "Ce champ est obligatoire.",
    "email": "Saisissez une adresse e-mail valide.",
    "passwordLength": "Utilisez de 8 à 128 caractères.",
    "otp": "Saisissez les 6 chiffres du code.",
    "recoveryCode": "Saisissez le code de récupération tel qu’il vous a été donné.",
    "nameLength": "Utilisez 100 caractères au maximum.",
    "phoneLength": "Utilisez 32 caractères au maximum.",
    "mismatch": "Les deux mots de passe sont différents."
  }
}
